<template>
    <v-dialog v-model="dialog" width="370">
    <v-card class="card">
      <v-card-title class="headline pb-4 pt-0 dialog_title" style="justify-content: center;">
        <h4>{{ title }}</h4>
      </v-card-title>
      <!-- <v-card-text class="pa-5 pt-2 pb-3 dialog_text text-center">{{ message }}</v-card-text> -->
      <v-card-text class="dialog_text text-center pt-5 pb-5 pa-0" v-html="message"></v-card-text>
      <v-card-actions class="pt-2 pa-0">
        <v-spacer></v-spacer>
        <v-btn class="dialog_btn" outlined large text @click="confirmAction">완료</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    title: String,
    message: String,
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    confirmAction() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Pretendard-Regular', sans-serif;
}
.card {
  padding: 20px;
}

.dialog_title {
  justify-content: center;
  border-bottom: 1px solid #D8D8D8;
}



.dialog_text {
  text-align: center;
  padding: 16px 0;
}

.dialog_btn {
  width: 100%;
  color: var(--primary-color) !important;
}
@media screen and (max-width:500px){
  .dialog_text { font-size: 12px;

}
}

</style>
